/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable max-len */
export const GOAL_SCOPE_FIELD_HINTS = {
  studyName:
    'Enter a unique name for this PCF study. This will appear on all reports and dashboards. Max 100 characters.',
  studyDescription:
    'Optional free-text description of the study purpose, context, or notes for internal reference.',
  productName:
    'The name of the product or material for which the PCF is being calculated. This will appear on the PCF report.',
  productCode:
    'Internal product identifier or SKU. Used for linking PCF results to inventory/ERP records.',
  industrySector:
    'The industrial sector of the product. Used to suggest relevant emission factor datasets and PCRs.',
  hsnCode: 'Map your product SKU to the relevant HSN code to standardize',
  reportingOrg:
    'The name of the company or entity commissioning the PCF study.',
  studyDate: 'The date the PCF study is initiated.',
  referenceYear:
    'Select the calendar year range the activity data represents. Use the same start and end year for a single year (e.g. 2024 to 2024), or a range for multi-year data (e.g. 2024 to 2026).',
  intendedApplication:
    'How will this PCF result be used? This determines the level of rigour required and which standards apply.',
  productCNCode:
    'CN code is relevant for mapping the product for CBAM regulatory complaince',
  pcfStandard:
    'The standard this PCF study will comply with. Governs which rules and requirements apply.',
  intendedAudiences: 'Who will receive the results of this study?',
  fuQuantity:
    "The numeric quantity of the reference flow. E.g., '1' in '1 kg of product.'",
  fuUnit: 'The unit of measurement for the functional unit.',
  fuDescription:
    'Free-text description completing the functional unit statement. Must describe: what the product does, how well, for how long, and in what context.',
  referenceFlow:
    'The measurable quantity of product that delivers the functional unit. Often the same as the FU but may differ for multi-functional systems.',
  boundaryScope:
    'Define which life cycle stages are included in this PCF study.',
  lifeCycleStages:
    'Checkbox selection of specific life cycle modules to include.',
  exclusions:
    'Describe any life cycle stages, processes, or flows that are excluded from the system boundary and justify why.',
  geographicScope:
    'The geographic region where the product is manufactured and the primary market.',
  allocationMethod:
    'The method to be used when distributing environmental burdens across multiple co-products of a shared process.',
  expertMode:
    'Show advanced inputs such as manual emission factor overrides and renewable energy certificate (REC) fields.'
} as const;
